export const callToActionTranslations = {
  nl: {
    title: "Bezoek Ons of Bestel Vandaag Nog!",
    subtitle: "Kom langs voor het volledige aanbod van groenten, producten en gerechten of bestel vanaf nu jouw favoriete Surinaamse gerechten online om te laten bezorgen of op te halen 😋",
    shopButton: "Winkel",
    orderButton: "Bestellen",
    marketButton: "Marktstand",
  },
  en: {
    title: "Visit Us or Order Today!",
    subtitle: "Come by for the full range of vegetables, products, and dishes, or order your favorite Surinamese dishes online now for delivery or pickup 😋",
    shopButton: "Shop",
    orderButton: "Order",
    marketButton: "Market Stall",
  },
};